
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinpowaimidc() {



    const cardData =
    {
        keyword: 'Corporate Cab Services in Powai MIDC Mumbai',
        heading: 'etravo : Corporate Cab Services in Powai MIDC Mumbai  ',



"headingDescription": "eTravo provides reliable Corporate Cab Services in Powai MIDC Mumbai, designed for IT companies, startups, and corporate offices that require seamless employee transportation, executive travel, and airport transfers. With GPS-enabled vehicles, professional chauffeurs, and flexible monthly plans, eTravo ensures safe, punctual, and efficient mobility across Powai’s major business zones including Hiranandani, Chandivali, and SEEPZ.",

"top": "Top Corporate Cab Services in Powai MIDC Mumbai with eTravo",

"topPlaces": [
  {
    "title": "",
    "description": "A highly rated cab provider in Powai offering 24/7 corporate transport solutions, including employee pickup and drop, airport transfers, and monthly contracts."
  },
  {
    "title": "",
    "description": "Provides reliable corporate cab services with GPS-enabled vehicles and professional drivers, suitable for IT companies and business travel in Powai MIDC."
  },
  {
    "title": "",
    "description": "Offers flexible corporate cab solutions with professional drivers, ideal for business meetings, airport transfers, and employee commute services."
  },
  {
    "title": "",
    "description": "A corporate-focused cab service provider offering scalable fleet solutions and business travel support for companies in Powai and Andheri MIDC."
  },
  {
    "title": "",
    "description": "Provides dependable corporate cab services with clean vehicles and trained drivers, suitable for daily office commute and executive travel."
  },
  {
    "title": "",
    "description": "Offers 24/7 cab rental and corporate transport services, including employee shuttle and business travel solutions in Powai MIDC."
  },
  {
    "title": "",
    "description": "Known for reliable chauffeur-driven services, catering to corporate clients with airport transfers and daily office travel."
  },
  {
    "title": "",
    "description": "Provides efficient and punctual cab services with a large fleet, suitable for corporate travel and employee transportation."
  },
  {
    "title": "",
    "description": "A well-established cab provider offering 24/7 corporate transportation, including intercity travel and employee commute solutions."
  },
  {
    "title": "",
    "description": "Specializes in corporate and outstation travel with reliable vehicles and experienced drivers for business trips and executive travel."
  }
],


"services": [
{
"name": "Corporate Cab Services in Powai MIDC Mumbai",
"description": "eTravo offers reliable corporate cab services in Powai MIDC Mumbai designed for smooth business travel. Our service ensures punctual pickups, comfortable rides, and professional chauffeurs for daily office commuting and executive travel."
},
{
"name": "Taxi Service Powai MIDC",
"description": "Our taxi services in Powai MIDC provide quick and dependable transportation for professionals and employees. eTravo ensures clean vehicles, timely service, and a hassle-free travel experience in and around Powai industrial and IT areas."
},
{
"name": "Company Cab Powai MIDC",
"description": "eTravo provides company cab services in Powai MIDC tailored for corporate needs. From employee transport to executive travel, our service ensures reliability, safety, and smooth operations."
},
{
"name": "Office Transport Powai MIDC",
"description": "Simplify employee commuting with eTravo’s office transport services in Powai MIDC. We offer structured and efficient transportation solutions for daily travel across IT parks and corporate offices."
},
{
"name": "Employee Cab Powai MIDC",
"description": "Our employee cab services in Powai MIDC are designed for safe and punctual commuting. eTravo ensures well-coordinated pickup and drop services for smooth daily travel."
},
{
"name": "Corporate Travel Powai MIDC",
"description": "eTravo offers corporate travel services in Powai MIDC for both local and outstation business needs. Our service ensures reliable and comfortable journeys for executives and teams."
},
{
"name": "Business Cab Powai MIDC",
"description": "eTravo’s business cab services in Powai MIDC are ideal for meetings, client visits, and corporate activities. Our service focuses on punctuality and professional travel experiences."
},
{
"name": "Staff Transport Powai MIDC",
"description": "eTravo provides dependable staff transport services in Powai MIDC for daily employee commuting. Our service ensures timely pickups, safe rides, and efficient travel coordination."
},
{
"name": "Corporate Taxi Powai MIDC",
"description": "Our corporate taxi services in Powai MIDC offer flexible and reliable transportation for businesses. eTravo ensures smooth travel for employees, executives, and corporate clients."
},
{
"name": "Company Taxi Powai MIDC",
"description": "eTravo’s company taxi services in Powai MIDC provide convenient travel solutions for corporate requirements. Our taxis are ideal for daily operations and client handling."
},
{
"name": "Corporate Pickup Drop Powai MIDC",
"description": "eTravo offers corporate pickup and drop services in Powai MIDC for efficient employee commuting. Our service ensures punctual scheduling and comfortable travel experiences."
},
{
"name": "Office Cab Booking Powai MIDC",
"description": "Book office cabs in Powai MIDC easily with eTravo. Our reliable service ensures timely pickups, comfortable rides, and hassle-free travel for corporate teams."
},
{
"name": "Business Travel Cab Powai MIDC",
"description": "Our business travel cab services in Powai MIDC are designed for professionals traveling for meetings and corporate tasks. eTravo ensures smooth and efficient journeys."
},
{
"name": "Corporate Commute Powai MIDC",
"description": "eTravo’s corporate commute services in Powai MIDC provide structured and dependable employee transportation. Our service ensures smooth daily travel for corporate staff."
},
{
"name": "Professional Cab Service Powai MIDC",
"description": "eTravo offers professional cab services in Powai MIDC with trained drivers and well-maintained vehicles. Our service ensures safe, comfortable, and reliable travel for all business needs."
}
],
"tableData": [
["Corporate Cab Services in Powai MIDC Mumbai", "Taxi Service Powai MIDC"],
["Company Cab Powai MIDC", "Office Transport Powai MIDC"],
["Employee Cab Powai MIDC", "Corporate Travel Powai MIDC"],
["Business Cab Powai MIDC", "Staff Transport Powai MIDC"],
["Corporate Taxi Powai MIDC", "Company Taxi Powai MIDC"],
["Corporate Pickup Drop Powai MIDC", "Office Cab Booking Powai MIDC"],
["Business Travel Cab Powai MIDC", "Corporate Commute Powai MIDC"],
["Professional Cab Service Powai MIDC", ""]
],




"whychoose": [
    {
      "WhyChooseheading": "Reliable Corporate Cab Services in Powai MIDC Mumbai",
      "WhyChoosedescription": "eTravo offers dependable corporate cab services in Powai MIDC Mumbai, ensuring smooth employee transportation for companies located in key business areas like Hiranandani Business Park and Chandivali."
    },
    {
      "WhyChooseheading": "Perfect for IT Parks and Industrial Workforce",
      "WhyChoosedescription": "Powai MIDC is a major commercial and IT hub in Mumbai, making corporate cab services essential for managing daily employee commute and business travel efficiently."
    },
    {
      "WhyChooseheading": "Daily Employee Pickup and Drop Solutions",
      "WhyChoosedescription": "Corporate cab services provide structured pickup and drop with route optimization, helping employees reach offices on time even in Mumbai’s heavy traffic conditions. :contentReference[oaicite:0]{index=0}"
    },
    {
      "WhyChooseheading": "Monthly Corporate Cab Contracts Available",
      "WhyChoosedescription": "Companies can opt for monthly corporate cab contracts with fixed routes, dedicated drivers, and cost-effective plans for regular employee commuting. :contentReference[oaicite:1]{index=1}"
    },
    {
      "WhyChooseheading": "Wide Fleet for Corporate Requirements",
      "WhyChoosedescription": "Corporate cab providers offer hatchbacks, sedans, SUVs, and executive vehicles, ensuring the right travel solution for employees, managers, and corporate guests."
    },
    {
      "WhyChooseheading": "Professional Chauffeurs and Safety Standards",
      "WhyChoosedescription": "Drivers are trained with corporate etiquette and safety protocols, ensuring secure and comfortable travel for employees and executives."
    },
    {
      "WhyChooseheading": "Flexible and Scalable Transport Solutions",
      "WhyChoosedescription": "Corporate cab services in Powai MIDC provide flexible plans including daily, monthly, and long-term rentals, allowing businesses to scale transport based on workforce size. :contentReference[oaicite:2]{index=2}"
    },
    {
      "WhyChooseheading": "24/7 Support for Corporate Travel Needs",
      "WhyChoosedescription": "Round-the-clock support ensures smooth coordination, quick issue resolution, and uninterrupted corporate mobility for businesses operating in Powai MIDC."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What are corporate cab services in Powai MIDC Mumbai?',
            answer: 'Corporate cab services in Powai MIDC Mumbai provide organized transportation for employees, executives, and clients including daily office commute, airport transfers, and business travel.',
        },
        {
            question: 'Why are corporate cab services important in Powai MIDC?',
            answer: 'Powai MIDC is a major IT and industrial hub, requiring reliable employee transportation to ensure punctuality and smooth business operations.',
        },
        {
            question: 'Do corporate cab services include daily pickup and drop?',
            answer: 'Yes, most services offer structured daily pickup and drop with fixed routes and schedules for employees. :contentReference[oaicite:3]{index=3}',
        },
        {
            question: 'Are monthly corporate cab packages available in Powai?',
            answer: 'Yes, companies can opt for monthly cab contracts with dedicated vehicles and drivers for regular commuting. :contentReference[oaicite:4]{index=4}',
        },
        {
            question: 'What types of vehicles are available for corporate travel?',
            answer: 'Vehicles include hatchbacks, sedans, SUVs, and luxury cars depending on employee and executive travel requirements.',
        },
        {
            question: 'Are corporate cab services safe for employees?',
            answer: 'Yes, services include GPS tracking, verified drivers, and safety protocols for secure employee transportation.',
        },
        {
            question: 'Can corporate travel plans be customized?',
            answer: 'Yes, businesses can customize routes, timings, and rental plans based on their workforce and operational needs.',
        },
        {
            question: 'Are corporate cab services available 24/7 in Powai MIDC?',
            answer: 'Yes, most providers operate round the clock to support shift-based operations and business travel.',
        },
        {
            question: 'Do corporate cab services provide airport transfers?',
            answer: 'Yes, airport pickup and drop services are available for employees and corporate clients traveling from Powai MIDC.',
        },
        {
            question: 'How can I book corporate cab services in Powai MIDC Mumbai?',
            answer: 'You can book through the service provider’s website or contact their support team for customized corporate travel solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Amit Sharma',
        designation: 'Operations Manager, IT Company, Powai Mumbai',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo provides excellent corporate cab services in Powai MIDC. Their punctual pickups and professional drivers make employee commute smooth and reliable.”',
    },
    {
        name: 'Ms. Neha Kapoor',
        designation: 'HR Manager, MNC, Powai Mumbai',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for employee transport in Powai MIDC. Their flexible plans and consistent service have improved our team’s daily commute.”',
    },
];







    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Powai MIDC Mumbai",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-powai-midc.jpg",
  "description": "Reliable corporate cab services in Powai MIDC, Mumbai by eTravo. Ideal for employee transport, office pickup and drop, business travel, and corporate commute with safe and professional service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-services-in-powai-midc-mumbai"
  }
};




    return (
        <div>


<Helmet>
  <title>Corporate Cab Services in Powai MIDC Mumbai | Office & Employee Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book corporate cab services in Powai MIDC, Mumbai with eTravo for employee transport, office pickup and drop, business travel, and corporate commute solutions. Safe and reliable rides." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/140.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinpowaimidc;